import { Link } from 'react-router-dom';
import React from 'react';

const ChartHeader = ({ children }) => <div className="chart__header">{children}</div>;

export default ChartHeader;
